import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  shouldWide: boolean;
  wide: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalContainer: {
      backgroundColor: 'white',
      maxWidth: ({ wide }: StyleProps) => wide,
      margin: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      padding: theme.spacing(4),
      borderRadius: 20,
      alignItems: 'center',
    },
    modalContainerHeader: {
      color: theme.oysterTheme.emerald,
      fontWeight: 'bold',
      fontSize: 24,
      lineHeight: ({ shouldWide }: StyleProps) => (shouldWide ? '41.66px' : '32px'),
      maxWidth: '452px',
      textAlign: 'center',
      whiteSpace: ({ shouldWide }: StyleProps) => (shouldWide ? 'break-spaces' : 'normal'),
    },
    modalContainerText: {
      fontSize: 14,
      fontWeight: 'normal',
      paddingTop: theme.spacing(2),
      lineHeight: '23.44px',
      maxWidth: '452px',
      textAlign: 'center',
      whiteSpace: ({ shouldWide }: StyleProps) => (shouldWide ? 'break-spaces' : 'normal'),
    },
    modalButtons: {
      placeContent: 'space-evenly',
      flexDirection: 'row-reverse',
      marginTop: ({ shouldWide }: StyleProps) =>
        shouldWide ? theme.spacing(5.75) : theme.spacing(2.5),
      '& div': { maxWidth: 'fit-content' },
    },
    cancelBtnContainer: {
      paddingTop: ({ shouldWide }: StyleProps) => (shouldWide ? 0 : theme.spacing(2)),
    },
    btn: {
      boxShadow: 'none',
    },
    btnSubmitting: {
      '&:disabled': {
        backgroundColor: theme.oysterTheme.pine,
        color: theme.oysterTheme.cotton,
      },
    },
    cancelBtn: {
      backgroundColor: theme.oysterTheme.cotton,
      color: theme.oysterTheme.pine,
      border: '2px solid rgba(191, 197, 204, 0.26)',
      '&:hover': { backgroundColor: theme.oysterTheme.cotton },
    },
  }),
);

export default useStyles;
